module.exports = __webpack_public_path__ + "img/ltkeurope-3x.fd137f6.jpg";